import React from "react";
import PropTypes from "prop-types";
import {
	CloudinaryImage,
	Separator,
} from "@website-builder/ui/shared/elements";

import { RatingWrapper, Container, Reviews, Underline } from "./styles";

const Rating = (props) => {
	const { ratings, ...restProps } = props;
	return (
		<RatingWrapper {...restProps}>
			{ratings.map((rating, index) => (
				<React.Fragment key={index}>
					<Container key={index}>
						<CloudinaryImage
							url={rating.logo?.image}
							lazyload
							sizes={{
								default: { height: 25 },
							}}
						/>
						<Reviews
							href={rating.ratingURL?.link}
							target={rating.ratingURL?.target}
						>
							<Underline>{rating.rating}/5</Underline>
							<span className="reviewCount">
								({rating.reviewCount} reviews)
							</span>
						</Reviews>
					</Container>
					{index !== ratings.length - 1 ? (
						<Separator className="separator" vertical />
					) : null}
				</React.Fragment>
			))}
		</RatingWrapper>
	);
};

Rating.propTypes = {
	ratings: PropTypes.array,
};

Rating.defaultProps = {
	ratings: [],
};

export default Rating;
